import { Component, Input, OnInit } from "@angular/core";
import { TelematicsService } from "../../services/telematics.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "common-order-item-utilization-chart",
  templateUrl: "./order-item-utilization-chart.component.html",
})
export class OrderItemUtilizationChartComponent implements OnInit {
  @Input() rentalRequestId: string;
  @Input() inventoryItemId: string;

  graphlabels: string[];
  monthlyData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      fill: boolean;
      cubicInterpolationMode: string;
      tension: number;
      yAxisID: string;
    }[];
  };
  constructor(private telematicsService: TelematicsService) {}

  ngOnInit(): void {
    this.telematicsService.getUtilizationForRentalRequestItem(this.rentalRequestId, this.inventoryItemId).subscribe(result => {
      const utilization = result.reverse();
      this.graphlabels = utilization.map(d => new DatePipe("en").transform(d.date, "shortDate"));

      // need to- get array of numbers
      let monthly = [24, 10];
      this.monthlyData = {
        labels: this.graphlabels,
        datasets: [
          {
            label: `Engine Hours`,
            data: utilization.map(d => (d.engineSeconds == -1 ? 0 : d.engineSeconds / 60 / 60)),
            borderColor: "#009688",
            backgroundColor: "#009688",
            fill: false,
            cubicInterpolationMode: "monotone",
            tension: 0,
            yAxisID: "y",
          },
          {
            label: `Idle Hours`,
            data: utilization.map(d => (d.idleSeconds == -1 ? 0 : d.idleSeconds / 60 / 60)),
            borderColor: "#f53331",
            backgroundColor: "#f53331",
            fill: false,
            cubicInterpolationMode: "monotone",
            tension: 0,
            yAxisID: "y",
          },
        ],
      };
    });
  }
}
